import { render, staticRenderFns } from "./FooterSetting.vue?vue&type=template&id=3a69ed44&"
import script from "./FooterSetting.vue?vue&type=script&lang=js&"
export * from "./FooterSetting.vue?vue&type=script&lang=js&"
import style0 from "./FooterSetting.vue?vue&type=style&index=0&id=3a69ed44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports